import { connect } from 'react-redux';
import * as R from 'ramda';
import {
  getAuthorizationBy,
  getInventoryOwner,
  getLocation,
  getParams,
  getProduct,
  getSelectedProducts,
  getSupplier,
} from '../../store/createNewSupplierAuthSlice';
import SummaryStep from './Summary';

const mapState = R.applySpec({
  authorizationBy: getAuthorizationBy,
  inventoryOwner: getInventoryOwner,
  location: getLocation,
  params: getParams,
  product: getProduct,
  selectedProducts: getSelectedProducts,
  supplier: getSupplier,
});

export default connect(mapState)(SummaryStep);
